// 日志报表
import request from '@/utils/request'


// 查询部门日志分页
export function pageByDept (data) {
  return request({
    url: '/crm/user-log/pageByDept',
    method: 'get',
    params: data
  })
}

// 部门日志列表上下邻线索
export function neighborByDept (data) {
  return request({
    url: '/crm/user-log/neighborByDept',
    method: 'get',
    params: data
  })
}

// C-新增日志时搜索当日上门客户线索
export function getTodayDoorCustomerPage (data) {
  return request({
    url: '/crm/customer/getTodayDoorCustomerPage',
    method: 'get',
    params: data
  })
}

// C-新增日志时搜索当日上门客户线索
export function todayLatestLogEcho (data) {
  return request({
    url: '/crm/user-log/todayLatestLogEcho',
    method: 'get',
    params: data
  })
}

// C-补录昨日日志回显
export function yesterdayLatestLogEcho (data) {
  return request({
    url: '/crm/user-log/yesterdayLatestLogEcho',
    method: 'get',
    params: data
  })
}

// C-新增日志
export function addLog (data) {
  return request({
    url: '/crm/user-log/addLog',
    method: 'post',
    data: data
  })
}

// C-新增昨日日志
export function addYesterdayLog (data) {
  return request({
    url: '/crm/user-log/addYesterdayLog',
    method: 'post',
    data: data
  })
}


// C-新增日志时搜索所有上门客户线索
export function getAllDoorCustomerPage (data) {
  return request({
    url: '/crm/customer/getAllDoorCustomerPage',
    method: 'get',
    params: data
  })
}


// C-写日志获取合同列表
export function getLogContract (data) {
  return request({
    url: '/crm/crmContract/getLogContract',
    method: 'get',
    params: data
  })
}


// C-今日提交日志人员
export function todaySubmitUsers (data) {
  return request({
    url: '/crm/user-log/todaySubmitUsers',
    method: 'get',
    params: data
  })
}


// C-是否已写昨日日志
export function hasYesterdayLog (data) {
  return request({
    url: '/crm/user-log/hasYesterdayLog',
    method: 'get',
    params: data
  })
}

// C-获取合同详情
export function crmContractDetail (data) {
  return request({
    url: '/crm/crmContract/detail',
    method: 'get',
    params: data
  })
}
